import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59912731")

_pushScopeId("data-v-59912731")
const _hoisted_1 = {
  key: 0,
  class: "update"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-2 center" }, " Une nouvelle version de l'application est disponible ", -1)
const _hoisted_3 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return ($setup.updateExists)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("dig-ui-standard-button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.refreshApp()))
          }, " Mettre à jour "),
          _createVNode("dig-ui-standard-button", {
            class: "cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.close()))
          }, " Annuler ")
        ])
      ]))
    : _createCommentVNode("", true)
})